import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  Grid
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FormatInputNumero, SelectAsincronico, SelectFree, TextFieldAutoComplete } from 'components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },

}));
export default function FormularioFecha(props) {
  const { errors, setValue, watch, } = props;
  const classes = useStyles();
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={12} xs={12}>
        <TextField size="small" type="date"  error={errors.fecha_presentacion != undefined} InputLabelProps={{ shrink: true }} helperText={errors.fecha_presentacion}  onChange={(e) => setValue('fecha_presentacion', e.target.value)}
        variant="outlined" fullWidth label="FECHA DE PRESENTACIÓN" name="fecha_presentacion" value={watch('fecha_presentacion')} />
      </Grid>
    </Grid>


  );
}
